// Interactive quiz definitions for the Silver-tier introductory assessments.
export const QUIZZES = {
  "thinking-style": {
    key: "thinking-style",
    title: "Thinking Style Quiz",
    subtitle: "Male? / Female? / Mixed? — discover the energy that leads your mind.",
    type: "category",
    accent: "#4E6E5D",
    questions: [
      { q: "When you face a new problem, your first instinct is to…", options: [
        { label: "Break it into logical, ordered steps", key: "M" },
        { label: "Feel out the whole situation intuitively", key: "F" },
        { label: "A bit of both, depending on the day", key: "X" } ] },
      { q: "In conversation, you naturally focus on…", options: [
        { label: "Facts, structure and outcomes", key: "M" },
        { label: "Feelings, mood and connection", key: "F" },
        { label: "Flowing between facts and feelings", key: "X" } ] },
      { q: "Your ideal way to make a decision is…", options: [
        { label: "Analyse the data and decide", key: "M" },
        { label: "Trust your gut and how it feels", key: "F" },
        { label: "Weigh logic and intuition together", key: "X" } ] },
      { q: "When you learn something new you prefer…", options: [
        { label: "Clear steps and a defined goal", key: "M" },
        { label: "Exploring freely and discovering", key: "F" },
        { label: "Some structure, some exploration", key: "X" } ] },
      { q: "Under pressure, you tend to become more…", options: [
        { label: "Focused, direct and driven", key: "M" },
        { label: "Reflective, receptive and calm", key: "F" },
        { label: "Adaptive — it shifts moment to moment", key: "X" } ] },
      { q: "Your energy feels most alive when you are…", options: [
        { label: "Building, pushing forward, achieving", key: "M" },
        { label: "Nurturing, receiving, being present", key: "F" },
        { label: "Balancing action and stillness", key: "X" } ] },
    ],
    results: {
      M: { title: "Yang · Male Thinking Style", blurb: "Your mind leads with active, logical, goal-directed energy. You move forward, structure, and achieve. Your growth edge: soften into receptive, intuitive (Yin) energy to find balance and rest.", color: "#4E6E5D" },
      F: { title: "Yin · Female Thinking Style", blurb: "Your mind leads with receptive, intuitive, feeling-centred energy. You sense, nurture, and connect. Your growth edge: invite in active, structured (Yang) energy to bring your visions into form.", color: "#8C6D46" },
      X: { title: "Mixed · Balanced Thinking Style", blurb: "You move fluidly between logic and intuition, action and receptivity. This adaptability is a gift — your practice is to stay conscious of which energy each moment truly needs.", color: "#D4A359" },
    },
  },
  "5-seasons": {
    key: "5-seasons",
    title: "5 Seasons — Who Am I?",
    subtitle: "Find your dominant element in the Five Element cycle.",
    type: "category",
    accent: "#4F8176",
    questions: [
      { q: "Which word most describes you at your best?", options: [
        { label: "Visionary & growing", key: "wood" },
        { label: "Joyful & radiant", key: "fire" },
        { label: "Grounded & nourishing", key: "earth" },
        { label: "Clear & principled", key: "metal" },
        { label: "Deep & wise", key: "water" } ] },
      { q: "Which season do you feel most alive in?", options: [
        { label: "Spring", key: "wood" },
        { label: "Summer", key: "fire" },
        { label: "Late Summer / harvest", key: "earth" },
        { label: "Autumn", key: "metal" },
        { label: "Winter", key: "water" } ] },
      { q: "When stressed, you most often feel…", options: [
        { label: "Frustrated or impatient", key: "wood" },
        { label: "Anxious or scattered", key: "fire" },
        { label: "Worried or over-giving", key: "earth" },
        { label: "Grief or rigidity", key: "metal" },
        { label: "Fearful or withdrawn", key: "water" } ] },
      { q: "Others come to you for…", options: [
        { label: "Direction & new ideas", key: "wood" },
        { label: "Warmth & inspiration", key: "fire" },
        { label: "Comfort & support", key: "earth" },
        { label: "Honesty & order", key: "metal" },
        { label: "Depth & reflection", key: "water" } ] },
      { q: "Your body tends to hold tension in your…", options: [
        { label: "Jaw, neck, tendons (Wood)", key: "wood" },
        { label: "Heart, chest (Fire)", key: "fire" },
        { label: "Stomach, digestion (Earth)", key: "earth" },
        { label: "Lungs, skin (Metal)", key: "metal" },
        { label: "Lower back, kidneys (Water)", key: "water" } ] },
      { q: "What do you most long for?", options: [
        { label: "Freedom to grow", key: "wood" },
        { label: "Love & connection", key: "fire" },
        { label: "Belonging & security", key: "earth" },
        { label: "Meaning & refinement", key: "metal" },
        { label: "Stillness & wisdom", key: "water" } ] },
    ],
    results: {
      wood: { title: "Wood · The Visionary (Spring)", blurb: "Wood energy is growth, vision and the courage to push through. You thrive with direction and room to expand. Balance frustration with flexibility and gentle stretching, sour foods, and green vegetables.", color: "#4F8176" },
      fire: { title: "Fire · The Radiant (Summer)", blurb: "Fire energy is joy, connection and warmth. You inspire others and love to be together. Balance over-excitement with calming breathwork, restful evenings, and bitter greens.", color: "#C25B4E" },
      earth: { title: "Earth · The Nurturer (Late Summer)", blurb: "Earth energy is nourishment, care and grounding. You are the centre others lean on. Balance over-giving with boundaries, warm whole grains, and steady routines.", color: "#C59B27" },
      metal: { title: "Metal · The Alchemist (Autumn)", blurb: "Metal energy is clarity, order and letting go. You value quality and truth. Balance rigidity and grief with breathwork, decluttering, and pungent foods like ginger and daikon.", color: "#8C8C8C" },
      water: { title: "Water · The Sage (Winter)", blurb: "Water energy is depth, wisdom and stillness. You restore through quiet and reflection. Balance fear with rest, warmth, gentle movement, and mineral-rich foods and soups.", color: "#3E5C76" },
    },
  },
  "7-levels": {
    key: "7-levels",
    title: "7 Levels of Vital Health",
    subtitle: "A quick self-assessment of where your vitality lives today.",
    type: "score",
    accent: "#D4A359",
    questions: [
      "I wake up feeling rested and physically energised.",
      "My digestion is comfortable and regular.",
      "My emotions feel balanced and I recover quickly from upset.",
      "My mind is clear and I focus easily.",
      "I feel connected to the people around me.",
      "I feel a sense of meaning and purpose in my days.",
      "I feel at peace and connected to something greater than myself.",
    ],
    bands: [
      { min: 7, max: 13, level: 2, title: "Level 1–2 · Building Foundations", blurb: "Your body is asking for gentle, consistent care — sleep, whole foods, and breath. Start with the Silver introductory practices and add one small daily ritual." },
      { min: 14, max: 20, level: 4, title: "Level 3–4 · Restoring Balance", blurb: "You have real foundations and room to deepen. Structured practice, seasonal foods, and Tai Chi Kung will lift your vitality noticeably — the Gold path is made for this stage." },
      { min: 21, max: 27, level: 6, title: "Level 5–6 · Thriving & Refining", blurb: "You live with strong vitality. Refine the subtle levels — emotional mastery, meaning, and spiritual connection — through the Diamond teachings and reflections." },
      { min: 28, max: 35, level: 7, title: "Level 7 · Radiant Wholeness", blurb: "You embody vibrant, integrated health across body, mind and spirit. Keep sharing your light — the deeper reflections and trainings will help you sustain and give it." },
    ],
  },
};

export const QUIZ_KEY_BY_CONTENT = { R01: "7-levels", R02: "thinking-style", R03: "5-seasons" };
